export default {
  data () {
    return {
      mapData: {},
      offerMarkers: [],
    }
  },

  methods: {
    setMapData (json) {
      this.mapData = json
    },
    
    offerListWrapperExist () {
      return document.querySelector('.listing-map__wrapper--offer-wrapper')
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/googleMap/ListingMapMixin.js